'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'link',
    shape: _react2.default.createElement('path', {
        d: 'M421.512 207.074l-85.795 85.767c-47.352 47.38-124.17 47.38-171.53 0-7.46-7.438-13.295-15.82-18.42-24.464l39.864-39.86c1.896-1.912 4.236-3.007 6.472-4.297 2.756 9.415 7.567 18.33 14.972 25.735 23.648 23.667 62.128 23.634 85.762 0l85.768-85.765c23.666-23.664 23.666-62.135 0-85.78-23.635-23.647-62.105-23.647-85.768 0l-30.5 30.53c-24.75-9.636-51.414-12.227-77.372-8.423l64.99-64.99c47.38-47.37 124.178-47.37 171.558 0 47.357 47.37 47.357 124.18 0 171.547zm-226.804 141.03l-30.52 30.532c-23.647 23.634-62.13 23.634-85.78 0-23.647-23.667-23.647-62.138 0-85.795l85.78-85.766c23.664-23.662 62.12-23.662 85.766 0 7.388 7.39 12.204 16.302 14.986 25.706 2.25-1.307 4.56-2.37 6.454-4.266l39.86-39.845c-5.09-8.68-10.957-17.03-18.42-24.478-47.348-47.37-124.172-47.37-171.543 0L35.527 249.96c-47.366 47.385-47.366 124.172 0 171.553 47.37 47.356 124.177 47.356 171.547 0l65.008-65.003c-25.97 3.826-52.643 1.213-77.372-8.406z'
    }),
    viewbox: '0 0 457.03 457.03',
    label: 'Link'

};
//# sourceMappingURL=link.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/link.js
 ** module id = 352
 ** module chunks = 0
 **/